/**
 * Primary Controller
 *
 *
 */

// the constructor for this object
function PrimaryController() { }

// the object
PrimaryController.prototype = {
    constructor: PrimaryController,

    // initialize the controller
    init: function()
    {
        // change the main logo link to go to the portal
        this._changeLogoLink();

        // set the google recaptcha site key
        this._setGoogleRecaptcha();

        // show the no customer accounts warning
        this._displayNoCustomerAccountsWarning();

        // display the uss admin links if the user has permission
        this._displayUssAdminLinks();

        // open the sidebar links based on the current uri
        this._openSideBarLinks();

        // initialize the chat
        this._initChat();

        // fill the services section of the sidebar
        this._populateSideBarServices();

        // show the link to the user management section
        this._showAccountUserManagement();

        // show the link for changing compliance pins
        this._showCompliancePins();

        // fill the resources section of the sidebar
        this._populateSideBarResources();

        PortalHelper.debugMessage('Primary Controller Initialized');
    },

    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Primary Controller Ran');
    },

    // register the javascript events
    _registerEvents: function()
    {
        // only register if the user is authenticated
        // if (PortalMain.PortalToken.getToken()) {
        //     this._konamiCode();
        // }
    },

    // have some fun
    // _konamiCode: function()
    // {
    //     var kKeys = [];
    //     var konami = "38,38,40,40,37,39,37,39,66,65";
    //     $(document).keydown(function(e) {
    //         kKeys.push( e.keyCode );
    //         if (kKeys.length > 10) {
    //             kKeys.shift();
    //         }
    //         if (kKeys.toString().indexOf( konami ) >= 0 ) {
    //             $("body").addClass("konami");
    //         }
    //     })
    // },

    // set the google recaptcha site key
    _setGoogleRecaptcha: function()
    {
        var siteKey = PortalConfig.recaptchaSiteKey;
        $('.g-recaptcha').attr('data-sitekey', siteKey);
    },

    // change the main logo to link to the portal dashboard instead of the website if logged in
    _changeLogoLink: function()
    {
        var user = PortalMain.PortalUser.getUser();

        if (user != false) {
            var dashboardUrl = PortalConfig.portalUrl + '/home/index';
            $('header.header .nav__logo').attr('href', dashboardUrl);
        }
    },

    // warn the user if they have no customer accounts
    _displayNoCustomerAccountsWarning: function()
    {
        var accounts = PortalMain.PortalAccounts.getAccounts();
        var portalDirectory = PortalMain.getControllerDirectory();
        var user = PortalMain.PortalToken.getPayload();

        if (user
        && portalDirectory != 'login'
        && portalDirectory != 'legal'
        && !accounts.length) {

            // show the warning popup
            $('#no-customer-accounts-warning').removeClass('hidden');
            if (user.uss_admin_level >= 1) {
                $('#no-customer-uss-admin').removeClass('hidden');
            }

            // hide the page
            var excludeDirectories = [
                'login',
                'admin',
                'users',
                'inquire'
            ];
            if ($.inArray(portalDirectory, excludeDirectories) == -1) {
                $('#portal-template').addClass('hidden');
            }
        }
    },

    // show the USS admin links if the user is a uss user
    _displayUssAdminLinks: function()
    {
        var user = PortalMain.PortalToken.getPayload();

        if (user.uss_admin_level >= 1) {
            $('#uss-admin-links').removeClass('hidden');
        }

        if (user.uss_admin_level >= 3) {
            $('#uss-login-as-user-link').removeClass('hidden');
        }
    },

    // open the sidebar links based on the current controller directory
    _openSideBarLinks: function()
    {
        var directory = PortalMain.getControllerDirectory();
        if (directory != undefined) {
            directory = directory.toLowerCase();
        }
        // loop through the link groups and auto-open the applicable ones
        $('li[data-portal-directories]').each(function() {
            var directories = $(this).attr('data-portal-directories').split('|');
            for(var i in directories) {
                directories[i] = directories[i].toLowerCase();
            }

            if (directories.indexOf(directory) != -1) {
                $(this).addClass('-open');
            }
        });
    },

    // initialize the chat box if in a specific directory
    _initChat: function()
    {
        var directory = PortalMain.getControllerDirectory();
        if (directory != undefined) {
            directory = directory.toLowerCase();
        }

        // the directories the chat should appear in
        var chatDirectories = [
            'service',
            'services',
            'tickets',
        ];

        if (directory != '') {
            if (chatDirectories.indexOf(directory) != -1) {

                // build the admin url
                var user = PortalMain.PortalUser.getUser();
                var adminUrl = PortalConfig.portalUrl;
                adminUrl += '/admin/get-user-accounts';
                adminUrl += '/' + user.user_id;
                var path = window.location.href;
                path = path.replace(PortalConfig.portalUrl, '');
                adminUrl += '?url=' + encodeURIComponent(path);
            }
        }
    },

    // populate the service links in the sidebar
    _populateSideBarServices: function()
    {
        var groups = PortalMain.PortalProducts.getProductGroups();
        if (groups === false) {
            return;
        }

        // prepend the all services link to the list
        groups.unshift({
            label: 'All Services',
            path: ''
        });

        // create a link for each group
        for (var i in groups) {

            var group = groups[i];

            // build the url for the product
            var url = PortalConfig.portalUrl;
            url += '/services/' + group.path;

            // clone the html and apply the link, and text
            var newLink = $('#service-links .clone-source').clone();
            newLink.removeClass('hidden clone-source');
            $('a', newLink).attr('href', url);
            $('a', newLink).html(group.label);

            $('#service-links').append(newLink);
        }
    },

    // show the user management link if the user has permissions
    _showAccountUserManagement: function()
    {
        var portalUserAccountIds = PortalHelper.getAdminAccountIDs();

        if (portalUserAccountIds.length > 0) {
            $('#sidebar-manage-user-accounts-link').removeClass('hidden');
            $('#sidebar-manage-accounts-link').removeClass('hidden');
        }
    },

    // show the user management link if the user has permissions
    _showCompliancePins: function()
    {
        var accounts = PortalMain.PortalAccounts.getAccounts();

        for (var i in accounts) {
            if (accounts[i].require_pin) {
                $('#sidebar-compliance-pins-link').removeClass('hidden');
            }
        }
    },

    // populate the resource category links in the sidebar
    _populateSideBarResources: function()
    {
        var resourceCategories = PortalMain.PortalResources.getResourceCategories();

        // add the root categories
        for (var i in resourceCategories) {
            var category = resourceCategories[i];
            if (category.parentCat == null) {

                // create the new link
                var newLink = $('#resource-links > .clone-source').clone();
                newLink.removeClass('hidden clone-source');

                // apply the category id
                newLink.attr('data-category-id', category.id);

                // apply the url
                var resourcesUrl = PortalConfig.portalUrl;
                resourcesUrl += '/resources/' + category.id;
                $('a', newLink).attr('href', resourcesUrl);

                // apply the link title
                $('a', newLink).html(category.title);

                // include the link
                $('#resource-links').append(newLink);
            }
        }

        // add the child categories
        for (var i in resourceCategories) {
            var category = resourceCategories[i];
            if (category.parentCat != null) {

                // get the parent category, and make it toggle-able
                var parentCategoryId = category.parentCat;
                var parentElement = $('#resource-links > li[data-category-id=' + parentCategoryId + ']');
                $('> a', parentElement).addClass('js-sidebar-menu-toggle');
                parentElement.addClass('-has-children');

                // apply the "all" link before child links can be appended
                var linkCount = $('li:not(.clone-source)', parentElement).length;
                if (linkCount == 0) {
                    var allCategory = {
                        id: parentElement.attr('data-category-id'),
                        title: 'All ' + $('a', parentElement).html()
                    }
                    this._appendResourcesChildLink(parentElement, allCategory);
                }

                // append the child link
                this._appendResourcesChildLink(parentElement, category);
            }
        }
    },

    _appendResourcesChildLink: function(parentElement, category)
    {
        // build the child link
        var newLink = $('ul > li.clone-source', parentElement).clone();
        newLink.removeClass('hidden clone-source');

        // apply the category id
        newLink.attr('data-category-id', category.id);

        // apply the url
        var resourcesUrl = PortalConfig.portalUrl;
        resourcesUrl += '/resources/' + category.id;
        $('a', newLink).attr('href', resourcesUrl);

        // apply the link title
        $('a', newLink).html(category.title);

        // include the link
        $('ul', parentElement).append(newLink);
    },
}